import { Size } from ".././MyHelpers";
import { PlayWindow } from "../api";
import { SlotSymbolSprite } from "./SlotSymbolSprite";
import { ReelSymbolsToDisplay } from "./SpinAnimation/ReelMapper";
import { IReelSetMapper, ReelSetMapper } from "./SpinAnimation/ReelSetMapper";
import { SpinnableReels, ISpinnableReels } from "./SpinAnimation/SpinnableReels";

export class SymbolsAnimation
{
	protected symbolSprites: SlotSymbolSprite[] = [];
	protected spinnableReels: SpinnableReels;
	protected reelSetMapper: ReelSetMapper;

	protected symbols: number[][] = [];
	protected windowSymbolSize: PlayWindow;

	protected running: boolean = false;

	// flag, to return symbols back to first frame after animation has stopped
	protected stopNextRedraw: boolean = false;

	public constructor(symbolSprites: SlotSymbolSprite[], spinnableReels: SpinnableReels, reelSetMapper: ReelSetMapper) {
		this.symbolSprites = symbolSprites;
		this.spinnableReels = spinnableReels;
		this.reelSetMapper = reelSetMapper;

		this.windowSymbolSize = this.spinnableReels.GetWindowSymbolSize();
	}

	public Start() {

		// get latest symbols
		this.symbols = this.reelSetMapper.GetSymbols(this.windowSymbolSize.Height);

		// start sprites
		for (let i = 0; i < this.symbolSprites.length; i++) {
			this.symbolSprites[i].Start();
		}

		this.running = true;
	}

	public Stop() {

		if (this.running) {
			for (let i = 0; i < this.symbolSprites.length; i++) {
				this.symbolSprites[i].Stop();
				this.symbolSprites[i].Reset();
			}

			this.running = false;
			this.stopNextRedraw = true;
		}
	}

	public Update() {

		if (this.running || this.stopNextRedraw) {

			// update frames
			for (let i = 0; i < this.symbolSprites.length; i++) {
				this.symbolSprites[i].Update();
			}

			// draw new frames
			for (let ri = 0 ; ri < this.symbols.length; ri++) {
				for (let si = 0; si < this.symbols[si].length; si++) {

					let s = this.symbols[ri][si];
					let canvas = this.spinnableReels.canvas[ri][si];
					this.symbolSprites[s].Draw(canvas);
				}
			}

			this.stopNextRedraw = false;
		}
	}
}


export class SymbolPositionToAnimate {
	public reel: number;
	public row: number;

	public constructor(reel: number, row: number) {
		this.reel = reel;
		this.row = row;
	}
}

export type DrawSymbolCallback = (reelIndex: number, rowIndex: number) => void;

export interface ICanDrawSymbol
{
	DrawSymbol(reelIndex: number, rowIndex: number): void;
}

export class SpecificSymbolsAnimation {
	protected symbolSprites: SlotSymbolSprite[] = [];
	protected spinnableReels: ISpinnableReels;
	protected reelSetMapper: IReelSetMapper;

	protected symbols: ReelSymbolsToDisplay[][] = [];
	protected windowSymbolSize: PlayWindow;

	protected running: boolean = false;

	// flag, to return symbols back to first frame after animation has stopped
	protected stopNextRedraw: boolean = false;


	protected symbolsToAnimate: SymbolPositionToAnimate[] = [];
	protected drawSymbolCallback: ICanDrawSymbol = null;

	constructor(symbolSprites: SlotSymbolSprite[], spinnableReels: ISpinnableReels, reelSetMapper: IReelSetMapper, drawSymbolCallback: ICanDrawSymbol)
	{
		this.symbolSprites = symbolSprites;
		this.spinnableReels = spinnableReels;
		this.reelSetMapper = reelSetMapper;

		this.windowSymbolSize = this.spinnableReels.GetWindowSymbolSize();
		this.drawSymbolCallback = drawSymbolCallback;
	}

	public Start(symbolsToAnimate: SymbolPositionToAnimate[]) 
	{
		
		
		this.symbolsToAnimate = symbolsToAnimate;

		// get latest symbols
		this.symbols = this.reelSetMapper.GetSymbols2();

		this.symbolsToAnimate.forEach((s) => {
			let reelMapper = this.reelSetMapper.GetReelMapper(s.reel).GetSymbols2()
		});

		// start sprites
		for (let i = 0; i < this.symbolSprites.length; i++) {
			this.symbolSprites[i].Start();
		}

		this.running = true;
	}

	public Stop() {
		if (this.running) {
			for (let i = 0; i < this.symbolSprites.length; i++) {
				this.symbolSprites[i].Stop();
				this.symbolSprites[i].Reset();
			}

			this.running = false;
			this.stopNextRedraw = true;
		}
	}

	public Update() {
		if (this.running || this.stopNextRedraw) {

			// update frames
			for (let i = 0; i < this.symbolSprites.length; i++) {
				this.symbolSprites[i].Update();
			}

			// draw new frames

			for (let i = 0; i < this.symbolsToAnimate.length; i++) {
				// let sa: SymbolPositionToAnimate = this.symbolsToAnimate[i];
				// let s: number = this.symbols[sa.reel][sa.row].symbolIndex;

				// let canvas = this.spinnableReels.CanvasesReelRow()[sa.reel][sa.row];

				// this.symbolSprites[s].Draw(canvas);

				this.drawSymbolCallback.DrawSymbol(this.symbolsToAnimate[i].reel,  this.symbolsToAnimate[i].row);
			}

			this.stopNextRedraw = false;
		}
	}
}